module.exports = __webpack_public_path__ + "img/product4.f18aa4cd.png";